import type { CartItem } from 'restful/tickets';

export const isCartItemOutOfStock = (item: CartItem) =>
  item.state === 'OutOfStock' || item.state === 'Unavailable';
